import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from '@ag-grid-community/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InlineSVGModule } from 'ng-inline-svg';
import { NgHeroiconsModule } from '@dimaslz/ng-heroicons';
import { ComponentsModule } from '@components/components.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { DirectivesModule } from '@directives/directives.module';
import { OverlayModule } from '@angular/cdk/overlay';
import { RouterModule } from '@angular/router';
import {
  DividerComponent,
  TypographyComponent,
  TypographyRuleComponent,
  TypographyTypeScaleComponent,
} from './typography';
import { ActionsComponent, TablesComponent } from './tables';
import { ModalDialogComponent, ModalComponent } from './modal';
import { FormsComponent } from './forms/forms.component';
import { ButtonsComponent } from './buttons/buttons.component';
import { IconographyComponent } from './iconography/iconography.component';
import { ColorsComponent } from './colors/colors.component';
import { DesignSystemComponent } from './design-system.component';
import { ButtonToggleComponentDemoComponent } from './button-toggle-component/button-toggle-component-demo.component';
import { TrialInsightsModule } from '../trial-insights/trial-insights.module';

@NgModule({
  declarations: [
    DividerComponent,
    TypographyComponent,
    TypographyRuleComponent,
    TypographyTypeScaleComponent,
    ActionsComponent,
    FormsComponent,
    ButtonsComponent,
    ModalDialogComponent,
    ModalComponent,
    IconographyComponent,
    TablesComponent,
    ColorsComponent,
    DesignSystemComponent,
    ButtonToggleComponentDemoComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgSelectModule,
    ComponentsModule,
    DirectivesModule,
    OverlayModule,
    NgHeroiconsModule,
    RouterModule,
    AgGridModule,
    InlineSVGModule,
    TrialInsightsModule,
  ],
})
export class DesignSystemModule {}
